export enum InsertLinkSource {
    OriginalRibbon = 'OriginalRibbon',
    FilePickerLinkContextMenu = 'FilePickerLinkContextMenu',
    ShortKey = 'ShortKey',
    FlightedRibbon = 'FlightedRibbon',
}
